import { ConfirmModal, MoreButton } from '@/components';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDeleteUser, useUser } from '../../hooks';

export const UserActionsButton: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id: userId } = useId();
  const { openMessage } = useMessage();

  const { mutateAsync: deleteUser } = useDeleteUser();
  const user = useUser(userId);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  if (!user.data || user.data.isIntegrated) {
    return null;
  }

  const handleClose = async () => {
    setOpenConfirmModal(false);
  };

  return (
    <>
      <MoreButton
        items={[
          {
            key: 'reset-password',
            label: t('reset-password'),
          },
          // {
          //   key: 'delete',
          //   label: t('invalidate'),
          //   danger: true,
          // },
        ]}
        onClick={({ key }) => {
          switch (key) {
            case 'reset-password':
              return navigate(key);
            case 'delete':
              return setOpenConfirmModal(true);
          }
        }}
      />
      <ConfirmModal
        open={openConfirmModal}
        title={t('invalidate-confirmation')}
        disclaimerText={t('delete-confirmation-disclaimer')}
        onOk={async () => {
          try {
            await deleteUser(userId);

            await Promise.all([
              openMessage('success', t('message-invalidate-completed')),
              (async () => {
                navigate('/tenant-manager?activeKey=users', { replace: true });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-invalidate-failed'));
          }
        }}
        onCancel={handleClose}
      />
    </>
  );
};
